import { META } from './data';

export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#1F3A2E] text-[#F2E8D5] mt-24">
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-14 grid md:grid-cols-[1.6fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif italic text-5xl">{META.brand}</p>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#C2A36B] mt-2">{META.tag}</p>
          <p className="font-serif text-sm text-[#F2E8D5]/55 mt-5 leading-[1.7] max-w-md">A small atelier on Via dei Calzaiuoli. We design and stitch eight collections a year for a private list of 1,400 readers. No advertising.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#C2A36B] mb-3">Atelier</p>
          <p className="font-serif text-sm text-[#F2E8D5]/85 leading-relaxed">Via dei Calzaiuoli 17<br />50122 Firenze, IT<br />By appointment only</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#C2A36B] mb-3">The catalogue</p>
          <p className="font-serif text-sm text-[#F2E8D5]/85 leading-[1.65]">Eight issues yearly · Printed on Munken Pure 100gsm · Sent by post on the 14th.</p>
          <button onClick={() => setPage('private')} className="mt-3 font-mono text-[10px] tracking-[0.32em] uppercase border-b border-[#C2A36B] text-[#C2A36B] hover:text-[#F2E8D5] hover:border-[#F2E8D5]">Request issue 47 →</button>
        </div>
      </div>
      <div className="border-t border-[#F2E8D5]/15 px-8 lg:px-14 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#F2E8D5]/40">
        <span>© 2026 {META.brand} · Atelier & catalogue · Firenze</span>
        <span>P. IVA IT 02451780488</span>
      </div>
    </footer>
  );
}
